import { useIntl } from 'react-intl'

export default function useFrequentQuestion() {
  const intl = useIntl()

  return [
    {
      id: 1,
      title: intl.messages['smb_acquisition_faq.question_1.question'],
      description: intl.messages['smb_acquisition_faq.question_1.answer'],
    },
    {
      id: 2,
      title: intl.messages['smb_acquisition_faq.question_2.question'],
      description: intl.messages['smb_acquisition_faq.question_2.answer'],
    },
    {
      id: 3,
      title: intl.messages['smb_acquisition_faq.question_3.question'],
      description: intl.messages['smb_acquisition_faq.question_3.full_answer'],
    },
    {
      id: 4,
      title: intl.messages['smb_acquisition_faq.question_4.question'],
      description: intl.messages['smb_acquisition_faq.question_4.answer'],
    },
    {
      id: 5,
      title: intl.messages['smb_acquisition_faq.question_5.question'],
      description: intl.messages['smb_acquisition_faq.question_5.answer'],
    },
    {
      id: 6,
      title: intl.messages['smb_acquisition_faq.question_6.question'],
      description: intl.messages['smb_acquisition_faq.question_6.answer'],
    },
    {
      id: 7,
      title: intl.messages['smb_acquisition_faq.question_7.question'],
      description: intl.messages['smb_acquisition_faq.question_7.answer'],
    },
    {
      id: 8,
      title: intl.messages['smb_acquisition_faq.question_8.question'],
      description: intl.messages['smb_acquisition_faq.question_8.answer'],
    },
    {
      id: 9,
      title: intl.messages['smb_acquisition_faq.question_9.question'],
      description: intl.messages['smb_acquisition_faq.question_9.answer'],
    },
    {
      id: 10,
      title: intl.messages['smb_acquisition_faq.question_10.question'],
      description: intl.messages['smb_acquisition_faq.question_10.answer'],
    },
    {
      id: 11,
      title: intl.messages['smb_acquisition_faq.question_11.question'],
      description: intl.messages['smb_acquisition_faq.question_11.answer'],
    },
    {
      id: 12,
      title: intl.messages['smb_acquisition_faq.question_12.question'],
      description: intl.messages['smb_acquisition_faq.question_12.full_answer'],
    },
  ]
}
